import { CONFIG_MANAGER_CLOSE, CONFIG_MANAGER_OPEN } from 'ConfigManager/actions'

export const configManagerOpen = (state = null, action) => {
  switch (action.type) {
    case CONFIG_MANAGER_OPEN:
      return true
    case CONFIG_MANAGER_CLOSE:
      return false
    default:
      return state
  }
}
